import { faBook, faCheckCircle, faCheckDouble, faEnvelope, faExclamation, faPen, faRefresh } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "@mui/material";
import { format, parse } from "date-fns";
import ptBR from "date-fns/locale/pt-BR/";

const StatusFiscalizacao = ({ value }) => {
  switch (value) {
    case 0:
      return (
        <Tooltip title="Em digitação" placement="right">
          <div className="status_digitacao">
            <FontAwesomeIcon icon={faPen} />
          </div>
        </Tooltip>
      )
    case 1:
      return (
        <Tooltip title="Aguardando análise" placement="right">
          <div className="status_pendente">
            <FontAwesomeIcon icon={faRefresh} />
          </div>
        </Tooltip>
      )
    case 2:
      return (
        <Tooltip title="Revisar solicitação" placement="right">
          <div className="status_revisao">
            <FontAwesomeIcon icon={faExclamation} />
          </div>
        </Tooltip>
      )
    case 4:
      return (
        <Tooltip title="Fiscalização solicitada" placement="right">
          <div className="status_favoravel_com_restricoes">
            <FontAwesomeIcon icon={faBook} />
          </div>
        </Tooltip>
      )
    case 5:
      return (
        <Tooltip title="Atualização MIG pendente" placement="right">
          <div className="status_homologado">
            <FontAwesomeIcon icon={faCheckCircle} />
          </div>
        </Tooltip>
      )
    case 6:
      return (
        <Tooltip title="Concluído" placement="right">
          <div className="status_homologado">
            <FontAwesomeIcon icon={faCheckDouble} />
          </div>
        </Tooltip>
      )
    case 7:
      return (
        <Tooltip title="Cancelada" placement="right">
          <div className="status_homologado">
            <FontAwesomeIcon icon={faEnvelope} />
          </div>
        </Tooltip>
      )
    case 8:
      return (
        <Tooltip title="Arquivada" placement="right">
          <div className="status_arquivada">
            <FontAwesomeIcon icon={faEnvelope} />
          </div>
        </Tooltip>
      )
  }
}

const columnsSolicitacaoFiscalizacao = [
  {
    field: 'SituacaoFiscalizacao', headerName: 'Situação',
    renderCell: (params) => (
      <StatusFiscalizacao value={params?.row?.SituacaoFiscalizacao} />
    )
  },
  {
    field: 'NumeroFiscalizacao', headerName: 'N° Solic. Fiscalização', flex: 0.37,
  },
  {
    field: 'Protocolo', headerName: 'N° Protocolo', flex: 0.37,
  },
  {
    field: 'CodigoSolicCompart', headerName: 'Solic. Compartilhamento', flex: 0.37,
    renderCell: (params) => {
      return params?.row?.SolicitacaoCompartilhamento?.CodigoVisual;
    }
  },
  {
    field: 'DataCadastro', headerName: 'Data cadastro', flex: 0.37,
    renderCell: (params) => {
      let dataFormatada = parse(params.value, 'dd/MM/yyyy HH:mm:ss', new Date());

      dataFormatada = format(dataFormatada, 'dd/MM/yyyy', {
        locale: ptBR
      });

      return dataFormatada;
    }
  },
  {
    field: 'PrazoAnalise', headerName: 'Prazo análise', flex: 0.37,
    renderCell: (params) => {
      let dataFormatada = parse(params.value, 'dd/MM/yyyy HH:mm:ss', new Date());

      dataFormatada = format(dataFormatada, 'dd/MM/yyyy', {
        locale: ptBR
      });

      return dataFormatada;
    }
  },
  {
    field: 'DataInicioInstalacao', headerName: 'Início instalação', flex: 0.37,
    renderCell: (params) => {
      let dataFormatada = parse(params.value, 'dd/MM/yyyy HH:mm:ss', new Date());

      dataFormatada = format(dataFormatada, 'dd/MM/yyyy', {
        locale: ptBR
      });

      return dataFormatada;
    }
  },
  {
    field: 'DataTerminoInstalacao', headerName: 'Término instalação', flex: 0.37,
    renderCell: (params) => {
      let dataFormatada = parse(params.value, 'dd/MM/yyyy HH:mm:ss', new Date());

      dataFormatada = format(dataFormatada, 'dd/MM/yyyy', {
        locale: ptBR
      });

      return dataFormatada;
    }
  },
  {
    field: 'DataConclusao', headerName: 'Conclusão', flex: 0.37,
    renderCell: (params) => {
      let dataFormatada = parse(params.value, 'dd/MM/yyyy HH:mm:ss', new Date());

      dataFormatada = format(dataFormatada, 'dd/MM/yyyy', {
        locale: ptBR
      });

      return dataFormatada;
    }
  },
];

export { columnsSolicitacaoFiscalizacao }